import { render, staticRenderFns } from "./LessonBlockTree.vue?vue&type=template&id=147edf14"
import script from "./LessonBlockTree.vue?vue&type=script&lang=js"
export * from "./LessonBlockTree.vue?vue&type=script&lang=js"
import style0 from "./LessonBlockTree.vue?vue&type=style&index=0&id=147edf14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports